module.exports = __webpack_public_path__ + "static/media/Lawn Gnome.45116304.jpg";